<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>증권 간략 정정</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>증권 간략 정정</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>증권 간략 정정</span>
          </button>
          <ul>
            <li>
              <router-link to="/contactpoint"
                ><span>알아두실 사항</span></router-link
              >
            </li>
            <li>
              <router-link to="/sbcpInpInqNdPolOtpt"
                ><span>청약 입력/조회 및 증권출력</span></router-link
              >
            </li>
            <li>
              <router-link to="/subsChangeForm"
                ><span>증권 간략 정정</span></router-link
              >
            </li>
            <li>
              <router-link to="/unpaidList"><span>미납조회</span></router-link>
            </li>
            <li>
              <router-link to="/staMon"><span>계약 통계</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="sortWrap type4">
          <dl>
            <dt class="w115">
              <label for="stockNum">증권번호</label>
              <div class="toolTip">
                <button type="button"><span>용어설명</span></button>
                <dl>
                  <dt>용어설명</dt>
                  <dd>과거 계약을 조회 복사하여 입력시 사용</dd>
                </dl>
              </div>
            </dt>
            <dd>
              <div class="inpTxt">
                <input
                  type="text"
                  id="stockNum"
                  v-model="state.polNo"
                  placeholder="증권번호를 입력해 주세요"
                  title="증권번호"
                />
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="searchBtn(true)">
            <span class="hide">검색</span>
          </button>
        </div>

        <h3 class="conTit">조회결과</h3>
        <div class="tabStyle1">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="200" />
              <col width="400" />
              <col width="200" />
              <col width="400" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">보험계약자</th>
                <td colspan="3">
                  <div class="typeSplit1">
                    <div class="inpTxt">
                      <input
                        type="text"
                        v-model="state.n_ctoren"
                        title="보험계약자1"
                      />
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        v-model="state.n_ctorkr"
                        title="보험계약자2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">팀 분류코드</th>
                <td colspan="3">
                  <div class="inpSlt">
                    <input
                      type="text"
                      class="sltBtn"
                      title="팀 분류코드 선택"
                      :value="teamCode()"
                      readonly
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">피보험자</th>
                <td colspan="3">
                  <div class="typeSplit1">
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.screenData.RelpeEngNm_01"
                        title="피보험자1"
                      />
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.screenData.RelpeKorNm_01"
                        title="피보험자2"
                      />
                    </div>
                  </div>
                  <div class="typeSplit1">
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.screenData.RelpeEngNm_02"
                        title="피보험자1_1"
                      />
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.screenData.RelpeKorNm_02"
                        title="피보험자1_2"
                      />
                    </div>
                  </div>
                  <div class="typeSplit1">
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.screenData.RelpeEngNm_03"
                        title="피보험자2_1"
                      />
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.screenData.RelpeKorNm_03"
                        title="피보험자2_2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  참조번호1
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>L/C번호, INVOICE번호등 기입(최대 20 bytes)</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="참조번호1 선택"
                        :value="getRefNo1List1()"
                      >
                        <span>{{getRefNo1List1()}}</span>
                      </button>
                      <ul>
                        <li
                          v-for="(d, index) in codeList.getRefNo1List"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            @click="onClickRefNo1List(d, index)"
                          >
                            <span>{{ d.name }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </ul>
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        placeholder="예시) INVOICE NO. PQC8678A"
                        title="참조번호1"
                        v-model="state.screenData.refnNoCd1"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  참조번호2
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>L/C번호, INVOICE번호등 기입(최대 20 bytes)</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="참조번호2 선택"
                        :value="getRefNo1List2()"
                      >
                       <span>{{getRefNo1List2()}}</span>
                      </button>
                      <ul>
                        <li
                          v-for="(d, index) in codeList.getRefNo1List"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            title="선택"
                            @click="onClickRefNo2List(d, index)"
                          >
                            <span>{{ d.name }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </ul>
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        placeholder="예시) L/C No. HTO285955"
                        title="참조번호2"
                        v-model="state.screenData.refnNoCd2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="startDay">출항일</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>선박등의 출항일자 표기</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="예시) 20230801"
                      id="startDay"
                      title="출항일"
                      v-model="state.screenData.tkffDd"
                      @change="onChangetkffDd"
                    />
                  </div>
                </td>
                <th scope="row">
                  질권은행
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>수입시 L/C를 오픈한 은행을 선택</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpSlt">
                    <input
                      type="text"
                      class="sltBtn"
                      title="질권은행 선택"
                      :value="clbank()"
                      readonly
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pol">출항지</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>먼저 도착할 국가를 선택한 후 도시를 선택함</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      id="pol"
                      title="출항지"
                      v-model="state.screenData.stplCd"
                    />
                  </div>
                </td>
                <th scope="row">
                  <label for="polModi">출항지 정정</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        좌측의 출발항란의 도시명과 실제 출력할 국가 및 도시명
                        입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="polModi"
                      title="출항지 정정"
                      v-model="state.screenData.stplNm"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pod">도착지</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>먼저 도착할 국가를 선택한 후 도시를 선택함</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      id="pod"
                      title="도착지"
                      v-model="state.screenData.ararCd"
                      readonly
                    />
                  </div>
                </td>
                <th scope="row">
                  <label for="podModi">도착지 정정</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        좌측의 도착항란의 도시명과 실재 출력할 국가 및 도시명
                        입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="podModi"
                      title="도착지 정정"
                      v-model="state.screenData.ararNm"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="claim">Claim지급지</label>
                </th>
                <td>
                  <div class="inpTxt">
                    <input type="text" id="claim" title="Claim지급지" 
                      v-model="formData.form.ctrRelpeEngNm23"/>
                  </div>
                </td>
                <th scope="row">원본부수</th>
                <td>
                  <div class="inpSlt">
                    <input
                      type="text"
                      class="sltBtn"
                      title="원본부수 선택"
                      v-model="state.screenData.polOrtxtNum"
                      v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')"
                      maxlength="1"
                      id="polOrt"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="startDay2">개시일</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      name="subs_ymd"
                      placeholder="예시) 20230801"
                      id="startDay2"
                      title="개시일"
                      v-model="state.screenData.insStdt"
                      @change="onChangeinsStdt"
                     
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  운송수단명
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        선박과 비행기 중 하나를 반드시 선택하시고 선박명을 알고
                        있는 경우 우측 빈칸에 입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <input
                        type="text"
                        class="sltBtn"
                        title="운송수단명 선택"
                        :value="trnMnCd()"
                        readonly
                      />
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        title="운송수단명"
                        v-model="state.screenData.ftrnOdNm"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pdtCode">품목코드</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        보험을 가입하는 물품을 선택하십시오. 보험가입물품이 여러
                        종류일 경우에는<br />
                        INVOICE AMOUNT 가 가장 큰 품목을 대표품목으로 선택하세요
                        (HS CODE 참조)<br />
                        주의: 보험요율 산출과 클레임 처리시 중요한 사항임으로
                        주의하여 선택하세요
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="선택해 주세요"
                      id="pdtCode"
                      title="품목코드"
                      v-model="state.screenData.itmCd"
                      readonly
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pdt">보험목적물</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        대표품목 및 수량만 입력하셔도 됩니다. (최대 60 bytes)
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTextarea typeReq">
                    <textarea
                      placeholder="내용을 입력하세요."
                      id="pdt"
                      v-model="state.screenData.dtlCon"
                    ></textarea>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">INVOICE금액</th>
                <td colspan="3">
                  <div class="typeSplit3">
                    <dl>
                      <dt>환종</dt>
                      <dd>
                        <div class="inpSlt">
                          <input
                            type="text"
                            class="sltBtn"
                            title="환종 선택"
                            v-model="state.screenData.ttInvcVamtCur"
                            readonly
                          />
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>
                        <label for="profit">희망이익률(%)</label>
                        <div class="toolTip">
                          <button type="button"><span>용어설명</span></button>
                          <dl>
                            <dt>용어설명</dt>
                            <dd>
                              화물이 목적지에 도착함으로써 화주가 얻을수 있는<br />
                              금전적 이익으로 110%가 일반적임.(최대 150%까지
                              입력가능)
                            </dd>
                          </dl>
                        </div>
                      </dt>
                      <dd>
                        <div class="inpTxt">
                          <input
                            type="text"
                            v-model="state.screenData.hopPftRt"
                            id="profit"
                            title="희망이익률"
                            class="tar"
                            readonly
                          />
                        </div>
                      </dd>
                    </dl>
                  </div>
                  <div class="typeSplit3">
                    <dl>
                      <dt>
                        <label for="load">갑판적율(%)</label>
                      </dt>
                      <dd>
                        <div class="inpTxt">
                          <input
                            type="text"
                            id="load"
                            title="갑판적율"
                            v-model="state.screenData.odshRt"
                            readonly
                          />
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>
                        <label for="pay">금액</label>
                        <div class="toolTip">
                          <button type="button"><span>용어설명</span></button>
                          <dl>
                            <dt>용어설명</dt>
                            <dd>INVOICE가액을 입력</dd>
                          </dl>
                        </div>
                      </dt>
                      <dd>
                        <div class="inpTxt">
                          <input
                            type="text"
                            placeholder="예시) 10000.35"
                            id="pay"
                            title="금액"
                            v-model="state.ttFormatInvcVamtAmt"
                            readonly
                          />
                        </div>
                      </dd>
                    </dl>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  포장형태
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>포장형태포장형태포장형태</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <input
                      type="text"
                      class="sltBtn"
                      title="포장형태 선택"
                      :value="packCd()"
                      readonly
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  보험조건
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        ALL RISK조건만 청약입력이 가능하며 기타 조건은
                        담당자가에게 FAX로 의뢰하시고 출력만 가능합니다
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <input
                      type="text"
                      class="sltBtn"
                      title="보험조건"
                      :value="getCovNm()"
                      readonly
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  부가조건1
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>기본조건외 추가로 담보를 원할 경우 사용</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      title="부가조건1"
                      v-model="state.screenData.acTerms1"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  부가조건
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>기본조건외 추가로 담보를 원할 경우 사용</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      title="부가조건2"
                      v-model="state.screenData.acTerms2"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  부가조건3
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>기본조건외 추가로 담보를 원할 경우 사용</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      title="부가조건3"
                      v-model="state.screenData.acTerms3"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  부가조건4
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>기본조건외 추가로 담보를 원할 경우 사용</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      title="부가조건4"
                      v-model="state.screenData.acTerms4"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="etc">기타조건</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        L/C 서류상 보험관련 문구를 입력하고자 할 경우 사용.(최대
                        60 bytes입력가능)
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTextarea typeReq">
                    <textarea
                      placeholder="내용을 입력하세요."
                      id="etc"
                      v-model="state.screenData.dtlCon_Etc"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="btnWrap">
          <a class="btnType sizeR colorB" @click="fnMdfBtn()"
            ><span>수정</span></a
          >
        </div>
      </div>
    </div>
  </div>
  <FnPolPrint ref="fnPolPrintRef" @close="handlePopupClose"></FnPolPrint>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  computed,
  inject,
  onMounted,
  onBeforeMount,
  onBeforeUpdate,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import _ from "lodash";
import * as codeList from "@/common/code";
import format from "date-fns/fp/format/index";
import FnPolPrint from "@/components/common/layerPop/FnPolPrint.vue";

const axios = inject("axios");
const fnPolPrintRef = ref(null);
window._ = _;

const swalAlert = inject("swalAlert");
const swalConfirm = inject("swalConfirm");
// let Result = ref([]);
let ResultTotal = ref([]);

const state = reactive({
  polNo: "",
  //화면에 표시
  biz_no: "",
  //피보험자
  bizpeNo: "",
  n_ctorkr: "",
  n_ctoren: "",
  screenData: {
    //계약자
    RelpeEngNm_: "",
    RelpeKorNm_: "",
    //보험 조건 & 부가조건
    covNm: "",
    acTerms1: "",
    acTerms2: "",
    acTerms3: "",
    acTerms4: "",

    RelpeEngNm_01: "",
    RelpeKorNm_01: "",
    RelpeEngNm_02: "",
    RelpeKorNm_02: "",
    RelpeEngNm_03: "",
    RelpeKorNm_03: "",

    logId: "",

    refnNoDivCd1: "",
    refnNoDivCd2: "",
    refnNoCd1: "",
    refnNoCd2: "",
    tkffDd: "",
    stplCd: "",
    stplNm: "",
    ararCd: "",
    ararNm: "",
    insStdt: "",
    sbcpDt: "",
    itmCd: "",
    hopPftRt: "",
    ftrnOdNm: "",
    trnMnCd: "",
    ttInvcVamtAmt: "",
    odshRt: "",
    dtlCon: "",
    ttInvcVamtCur: "",
    packCd: "",
    polOrtxt: "",
    polOrtxtNum: "",
    dtlCon_Etc: "",
    tmp  : [],
    tmp2 : [],
    tmp3 : [],
    tmp4 : [],
    tmp5 : [],
    tmp6 : [],
  },
});

// 정정 저장시 나중에 같이 포함되야 할 데이터 ( 화면에는 보여주지 않음 )
const formData = {
  form: {
    covCd: "",
    adjtCd: "",
    itmCdNm: "",
    invcVamtCurCd: "",
    invcVamt: "",
    hsCd: "",
    ctrPtySeq: "",
    hisSeq: "",
    ctrId: "",
    endrHisStdNo: "",
    acpShDivCd: "",
    agrmNagrmDiv: "",
    aplExrtDt: "",
    basCovCd: "",
    cargTrnDtlsDivCd: "05",
    cmcMnUstmnYn: "2",
    dsgDivCd: "",
    dsgDt: "",
    insVamtCurCd: "",
    pdCd: "",
    pyMd: "99",
    sbcpChnDivCd: "03",
    ttSbcAmt: "",
    untPdCd: "",
    uY: "",
    vygZoneCd: "",
    trnMnCd1: "",
    dsgDiv: "",
    polhdDiv: "",
    endrNo: "",
    otptSh: "1",
    otptDiv: "100804",
    ftrnOdSeq: "",

    hisSeqCag : "",

    //계약자
    ctrPtySeq01 : "",
    atlCtrPtySeq01 : "",
    atlCtrId01 : "",
    ctrId01 : "",
    ptyId01 : "",
    adjtCd01 : "",
    hisSeq01 : "",
    ptyDivCd01 : "",
    rowStat01: "",
    dataId01 : "",
    //피보험자
    ctrPtySeq02 : "",
    atlCtrPtySeq02 : "",
    atlCtrId02 : "",
    ctrId02 : "",
    ptyId02 : "",
    adjtCd02 : "",
    hisSeq02 : "",
    ptyDivCd02 : "",
    rowStat02: "",
    dataId02 : "",
    //질권자
    ctrPtySeq11 : "",
    atlCtrPtySeq11 : "",
    atlCtrId11 : "",
    ctrId11 : "",
    ptyId11 : "",
    adjtCd11 : "",
    hisSeq11 : "",
    ctrRelpeEngNm11 : "",
    ctrRelpeKorNm11 : "",
    ptyDivCd11 : "",
    rowStat11: "",
    dataId11 : "",
    //claim지급지
    ptyId23 : "",
    atlCtrPtySeq23 : "",
    atlCtrId23 : "",
    ctrPtySeq23 : "",
    ctrId23 : "",
    ctrRelpeEngNm23 : "",
    ctrRelpeKorNm23 : "",
    adjtCd23 : "",
    hisSeq23 : "",
    ptyDivCd23 : "",
    rowStat23: "",
    dataId23 : "",
  },
};

//페이지 진입시
onMounted(async () => {
  await load();
  console.log("로그인 정보값", sessionUserInfo);
  state.screenData.logId = sessionUserInfo.logId;
  state.n_ctoren = sessionUserInfo.userInfo.n_ctoren;
  state.n_ctorkr = sessionUserInfo.userInfo.n_ctorkr;
  state.biz_no = sessionUserInfo.userInfo.biz_no;
});

const inputHandler = (e) => {
  /* 미러링 시 v-model 데이터 */
  e.target.setAttribute('value', e.target.value)
  emit('input')
}

//증권 간략 정정 증권번호 조회  FNGCTNFO0142
const searchBtn = async (reset) => {
  if (reset) {
    state.screenData = {};
    formData.form = {};
  }

  let param = {
    acpShDivCd: "",
    inetUsrId: "",
    endrHisStdNo: "0",
    inetDivCd: "1",
    polNo: state.polNo, //21010-1632156
  };


  if (param.polNo.length < 6) {
    swalAlert("입력값을 확인하십시오.");
    return;
  } else {
    let Result = await axios.transaction("FNGCTNFO0142", param);
    ResultTotal = Result.body;
    //팀 분류코드

    //피보험자 123
    let mrinSbcDsgCtrRelpeInfBcVo = _.flatten([
      Result.body.mrinSbcDsgCtrRelpeInfBcVo,
    ]);

    //운송 수단 코드 & 운송 수단명  ftrnOdSeq
    let gnrMrinFtrnOdVo = _.flatten([
      Result.body.gnrMrinFtrnOdVo,
    ]);

    state.screenData.tmp = [];
    state.screenData.tmp2 = [];
    state.screenData.tmp3 = [];
    state.screenData.tmp4 = [];

    state.screenData.tmp5 = [];
    state.screenData.tmp6 = [];

    mrinSbcDsgCtrRelpeInfBcVo.forEach((data) => {
      if (data != null) {
        state.screenData.tmp = _.filter(mrinSbcDsgCtrRelpeInfBcVo, (d) => {
          return d.ctrPtyRlCd == "01";
        });
        state.screenData.tmp2 = _.filter(mrinSbcDsgCtrRelpeInfBcVo, (d) => {
          return d.ctrPtyRlCd == "02";
        });
        state.screenData.tmp3 = _.filter(mrinSbcDsgCtrRelpeInfBcVo, (d) => {
          return d.ctrPtyRlCd == "11";
        });
        state.screenData.tmp4 = _.filter(mrinSbcDsgCtrRelpeInfBcVo, (d) => {
          return d.ctrPtyRlCd == "23";
        });
      }
    });

    gnrMrinFtrnOdVo.forEach((data) =>{
      if(data != null){
        state.screenData.tmp5 = _.filter(gnrMrinFtrnOdVo, (d) => {
          return d.ftrnOdSeq == "1";
        }); 
        state.screenData.tmp6 = _.filter(gnrMrinFtrnOdVo, (d) => {
          return d.ftrnOdSeq == "2";
        }); 
      }
    });

    //계약자 셋팅
    state.screenData.tmp.forEach((data) => {
      formData.form.adjtCd01 = data.adjtCd;
      state.bizpeNo = data.bizpeNo;
      formData.form.ctrPtySeq01 = data.ctrPtySeq;
      formData.form.ctrId01 = data.ctrId;
      formData.form.hisSeq01  = data.hisSeq;
      formData.form.atlCtrId01 = data.atlCtrId;
      formData.form.ptyId01 = data.ptyId;
      formData.form.ptyDivCd01 =data.ptyDivCd;
      formData.form.atlCtrPtySeq01 =data.atlCtrPtySeq;
      formData.form.dataId01 = data.dataId;
      formData.form.rowStat23 = data.rowStat;

    });
    if (state.bizpeNo != "" && state.bizpeNo != state.biz_no) {
      swalAlert("조회할 수 없는 계약 입니다.");
      return;
    }

    //피보험자 이름 셋팅
    state.screenData.tmp2.forEach((data, index) => {
      let RelpeEngNm = data.ctrRelpeEngNm;
      let RelpeKorNm = data.ctrRelpeKorNm;
      state.screenData["RelpeEngNm_0" + (index + 1)] = RelpeEngNm.trim();
      state.screenData["RelpeKorNm_0" + (index + 1)] = RelpeKorNm.trim();
      formData.form.hisSeq02  = data.hisSeq;
      formData.form.ctrPtySeq02 = data.ctrPtySeq;
      formData.form.atlCtrId02 = data.atlCtrId;
      formData.form.ctrId02 = data.ctrId;
      formData.form.ptyId02 = data.ptyId;
      formData.form.adjtCd02 = data.adjtCd;
      formData.form.ptyDivCd02 = data.ptyDivCd;
      formData.form.atlCtrPtySeq02 =data.atlCtrPtySeq;
      formData.form.dataId02 = data.dataId;
      formData.form.rowStat02 = data.rowStat;

    });

    //질권은행
    state.screenData.tmp3.forEach((data) => {
      formData.form.ptyId11 = data.ptyId;
      formData.form.ctrPtySeq11 = data.ctrPtySeq;
      formData.form.hisSeq11 = data.hisSeq;
      formData.form.atlCtrId11 = data.atlCtrId;
      formData.form.ctrId11 = data.ctrId;
      formData.form.adjtCd11 = data.adjtCd;
      formData.form.ctrRelpeEngNm11 = data.ctrRelpeEngNm;
      formData.form.ctrRelpeKorNm11 = data.ctrRelpeKorNm;
      formData.form.ptyDivCd11 = data.ptyDivCd;
      formData.form.atlCtrPtySeq11 =data.atlCtrPtySeq;
      formData.form.dataId11 = data.dataId;
      formData.form.rowStat11 = data.rowStat;

    });
    
    // formData.form.ptyId = Result.body.mrinSbcDsgCtrRelpeInfBcVo.ptyId;

    formData.form.refnNoDivCd1 = Result.body.refnNoDivCd1; //참조번호 구분코드1  refnNoDivCd1
    formData.form.refnNoDivCd2 = Result.body.refnNoDivCd2; //참조번호 구분코드2  refnNoDivCd2

    state.screenData.refnNoCd1 = Result.body.refnNoCd1; //참조번호1
    
    state.screenData.refnNoCd2 = Result.body.refnNoCd2; //참조번호2

    state.screenData.tkffDd = Result.body.tkffDd; //출항일

    state.screenData.stplCd = Result.body.stplCd; //출항지
    state.screenData.stplNm = Result.body.stplNm; //출항지 정정
    state.screenData.ararCd = Result.body.ararCd; //도착지
    state.screenData.ararNm = Result.body.ararNm; //도착지 정정

    //claim 지급지
    state.screenData.tmp4.forEach((data) => {
      formData.form.ctrPtySeq23 = data.ctrPtySeq;
      formData.form.ctrId23 = data.ctrId;
      formData.form.ptyId23 = data.ptyId;
      formData.form.ctrRelpeEngNm23 = data.ctrRelpeEngNm.trim()
      formData.form.ctrRelpeKorNm23 = data.ctrRelpeKorNm.trim()
      formData.form.hisSeq23  = data.hisSeq;
      formData.form.atlCtrId23  = data.atlCtrId;
      formData.form.adjtCd23  = data.adjtCd;
      formData.form.ptyDivCd23  = data.ptyDivCd;
      formData.form.atlCtrPtySeq23 =data.atlCtrPtySeq;
      formData.form.dataId23 = data.dataId;
      formData.form.rowStat23 = data.rowStat;
    });

    formData.form.polOrtxt = Result.body.polOrtxtNum; //원본 부수
    state.screenData.polOrtxtNum = Result.body.polOrtxtNum; //원본 부수 추가
    state.screenData.insStdt = Result.body.insStdt; //개시일
    
    state.screenData.tmp5.forEach((data) => {
      formData.form.trnMnCd = data.trnMnCd; //운송수단 코드
      formData.form.ftrnOdSeq = data.ftrnOdSeq; //운송수단 순번
      state.screenData.ftrnOdNm = data.ftrnOdNm; //운송수단 명
    });
    
    
    state.screenData.dtlCon = "";
    state.screenData.dtlCon_Etc = "";
    //보험 목적물- concd G002
    let prctrDtlCons = _.filter(Result.body.prctrDtlConBcVo, (d) => {
      return d.ctrConCd == "G002";
    });
    prctrDtlCons.forEach((element) => {
      state.screenData.dtlCon += element.dtlCon + "\n";
    });

    //보험 목적물 기타 문헌- concd G003
    let prctrDtlConsEtc = _.filter(Result.body.prctrDtlConBcVo, (d) => {
      return d.ctrConCd == "G003";
    });

    prctrDtlConsEtc.forEach((element) => {
      state.screenData.dtlCon_Etc += element.dtlCon + "\n";
    });
    state.screenData.ttInvcVamtCur = Result.body.ttInvcVamtCur; //환종
    state.screenData.hopPftRt = Result.body.hopPftRt; //희망 이익률
    state.screenData.odshRt = Result.body.odshRt; //갑판적율
    state.screenData.ttInvcVamtAmt = Result.body.ttInvcVamtAmt; //금액
    state.ttFormatInvcVamtAmt = state.screenData.ttInvcVamtAmt; //검색시 소수점 맞추기
    formatAmt();

    formData.form.hsCd = Result.body.cargSbcDsgObjInfBcVo.hsCd; // HS코드
    
    formData.form.hisSeq = Result.body.hisSeq; // hisseq

    formData.form.invcVamt = Result.body.cargSbcDsgObjInfBcVo.invcVamt; // 송장가액
    formData.form.invcVamtCurCd =
      Result.body.cargSbcDsgObjInfBcVo.invcVamtCurCd; // 송장가액환종코드
    state.screenData.itmCd = Result.body.cargSbcDsgObjInfBcVo.itmCd; //품목코드
    formData.form.itmCdNm = Result.body.cargSbcDsgObjInfBcVo.itmCdNm; // 품목코드명
    formData.form.packCd = Result.body.cargSbcDsgObjInfBcVo.packCd; //포장형태

    let mrinSbcDsgCovInfBcVo = _.flatten([Result.body.mrinSbcDsgCovInfBcVo]);
    let mrinSbcDsgBasCovInfBcVo = _.findLast(mrinSbcDsgCovInfBcVo, (d) => {
      return d.covDivCd == "1";
    });
    let mrinSbcDsgAddCovInfBcVo = _.filter(mrinSbcDsgCovInfBcVo, (d) => {
      return d.covDivCd != "1";
    });
    formData.form.covCd = mrinSbcDsgBasCovInfBcVo.covCd;

    mrinSbcDsgAddCovInfBcVo.forEach((data, index) => {
      //부가조건 1234
      let str = data.covNm;
      if (data.covtpAddTrmVal != "") {
        str += " (" + data.covtpAddTrmVal + " " + data.addTrmUnt + ")";
      }
      state.screenData["acTerms" + (index + 1)] = str;
    });

    //기타조건

    //수정시 보내는 데이터(화면 표시 x)
    state.screenData.sbcpDt = Result.body.sbcpDt; //청약일
    formData.form.ctrId = Result.body.ctrId;
    formData.form.endrHisStdNo = Result.body.endrHisStdNo;
    formData.form.acpShDivCd = Result.body.acpShDivCd;
    formData.form.agrmNagrmDiv = Result.body.agrmNagrmDiv;
    formData.form.aplExrtDt = Result.body.aplExrtDt;
    formData.form.basCovCd = Result.body.basCovCd;
    formData.form.cargTrnDtlsDivCd = Result.body.cargTrnDtlsDivCd;
    formData.form.cmcMnUstmnYn = Result.body.cmcMnUstmnYn;
    formData.form.dsgDivCd = Result.body.dsgDivCd;
    formData.form.dsgDt = Result.body.dsgDt;
    formData.form.insVamtCurCd = Result.body.insVamtCurCd;
    formData.form.pdCd = Result.body.pdCd;
    formData.form.pyMd = Result.body.pyMd;
    formData.form.sbcpChnDivCd = Result.body.sbcpChnDivCd;
    formData.form.ttSbcAmt = Result.body.ttSbcAmt;
    formData.form.untPdCd = Result.body.untPdCd;
    formData.form.uY = Result.body.uY;
    formData.form.vygZoneCd = Result.body.vygZoneCd;
    formData.form.trnMnCd1 = Result.body.trnMnCd1;
    formData.form.dsgDiv = Result.body.dsgDiv;
    formData.form.polhdDiv = Result.body.polhdDiv;
    
    
  }
};

//참조번호1
const getRefNo1List1 = () => {
  return _.isEmpty(formData.form.refnNoDivCd1)
    ? ""
    : _.find(codeList.getRefNo1List, (d) => {
        return d.code.startsWith(formData.form.refnNoDivCd1);
      })?.name || "";
};
//참조번호2
const getRefNo1List2 = () => {
  return _.isEmpty(formData.form.refnNoDivCd2)
    ? ""
    : _.find(codeList.getRefNo1List, (d) => {
        return d.code.startsWith(formData.form.refnNoDivCd2);
      })?.name || "";
};
//원본 부수
const polOrtxt = () => {
  return _.isEmpty(formData.form.polOrtxt)
    ? ""
    : _.find(codeList.getOrigCntCodeList, (d) => {
        return d.code.startsWith(formData.form.polOrtxt);
      })?.name || "";
};

//운송수단
const trnMnCd = () => {
  return _.isEmpty(formData.form.trnMnCd)
    ? ""
    : _.find(codeList.getTrsMethCodeList, (d) => {
        return d.code.startsWith(formData.form.trnMnCd);
      })?.name || "";
};

//포장형태
const packCd = () => {
  return _.isEmpty(formData.form.packCd)
    ? ""
    : _.find(codeList.getPackageTypeList, (d) => {
        return d.code.startsWith(formData.form.packCd);
      })?.name || "";
};

//보험 조건 공통
const getCovNm = () => {
  return _.isEmpty(formData.form.covCd)
    ? ""
    : _.find(codeList.getInsCondList, (d) => {
        return d.code.startsWith(formData.form.covCd);
      })?.name || "";
};

//질권 은행
const clbank = () => {
  return _.isEmpty(formData.form.ptyId)
    ? ""
    : _.find(codeList.getBankCodeList, (d) => {
        return d.code.startsWith(formData.form.ptyId);
      })?.name || "";
};

//팀분류 코드
const teamCode = () => {
  //   return _.isEmpty(formData.form.clbank)
  //     ? ""
  //     : _.find(codeList.useTeamCodeStore, (d) => {
  //         return d.code.startsWith(formData.form.clbank);
  //       })?.name || "";
};

const onClickRefNo1List = async (d) => {
  formData.form.refnNoDivCd1 = "";
  formData.form.refnNoDivCd1 += d.code;
  console.log("참조번호 다시 선택1", formData.form.refnNoDivCd1);
};
const onClickRefNo2List = async (d) => {
  formData.form.refnNoDivCd2 = "";
  formData.form.refnNoDivCd2 += d.code;
  console.log("참조번호 다시 선택2", formData.form.refnNoDivCd2);
};

//
//
//증권 간략 정정 수정 저장 FNGCTNFO0191
//
//

const fnMdfBtn = async () => {
  if (state.polNo.length >= 6) {
    // 보험개시일변경 제어
    // if (!onChangeinsStdt()) {
    //   return;
    // }
    // for (let i = 1; i < state.polNo.length; i++) {
    //   state.polNo = state.polNo
    //     .replace("<", "&lt;")
    //     .replace(">", "&gt;")
    //     .replace('"', "&#34;")
    //     .replace("<'", "&#39;")
    //     .replace("%00", null)
    //     .replace("%", "&#39;");
    // }
  } else {
    swalAlert("입력값을 확인하십시오.");
  }

  if(state.screenData.polOrtxtNum == "" || state.screenData.polOrtxtNum < 1 || state.screenData.polOrtxtNum > 5){
     swalAlert("원본부수는 1매에서 ~ 5매 만 가능합니다.");
  }


  let mrinSbcDsgCtrRelpeInfBcVoLst = [];
  let prctrDtlConBcVoLst = [];
  let gnrMrinFtrnOdVoLst = [];
  let CargSbcDsgObjInfBcVoLst = [];

  // 01 : 계약자
  let mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = formData.form.adjtCd01; //팀분류코드
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = state.biz_no;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrId = formData.form.atlCtrId01;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrPtySeq = formData.form.atlCtrPtySeq01;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "01";
  mrinSbcDsgCtrRelpeInfBcVo.ctrId = formData.form.ctrId01;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "계약자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = formData.form.ctrPtySeq01;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = sessionUserInfo.userInfo.corp_no;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = sessionUserInfo.userInfo.n_ctoren;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = sessionUserInfo.userInfo.n_ctorkr;
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = sessionUserInfo.slzCusInf.cusNo;
  mrinSbcDsgCtrRelpeInfBcVo.hisSeq = formData.form.hisSeq01;
  mrinSbcDsgCtrRelpeInfBcVo.dataId =  formData.form.dataId01;
  mrinSbcDsgCtrRelpeInfBcVo.rowStat = formData.form.rowStat01;
  if (sessionUserInfo.userInfo.ind_corp_typ_cd == "C") {
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "4";
  } else {
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "2";
  }
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = formData.form.ptyDivCd01;
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = formData.form.ptyId01;

  mrinSbcDsgCtrRelpeInfBcVoLst.push(mrinSbcDsgCtrRelpeInfBcVo);

  //피보험자 2, 3 (ENG)
  let strInsr_Eng = [];
  //1
  strInsr_Eng += state.screenData.RelpeEngNm_01;
  //2
  if ("" == state.screenData.RelpeEngNm_02) {
    strInsr_Eng += "";
  } else if ("" == strInsr_Eng) {
    strInsr_Eng += state.screenData.RelpeEngNm_02;
  }
  //  else {
  //   strInsr_Eng += "/" + state.screenData.RelpeEngNm_02;
  // }

  //3
  if ("" == state.screenData.RelpeEngNm_03) {
    strInsr_Eng += "";
  } else if ("" == strInsr_Eng) {
    strInsr_Eng += state.screenData.RelpeEngNm_03;
  }
  //  else {
  //   strInsr_Eng += "/" + state.screenData.RelpeEngNm_03;
  // }

  //피보험자 2, 3 (KOR)
  let strInsr_Kor = [];
  //1
  strInsr_Kor += state.screenData.RelpeKorNm_01;
  //2
  if ("" == state.screenData.RelpeKorNm_02) {
    strInsr_Kor += "";
  } else if ("" == strInsr_Kor) {
    strInsr_Kor += state.screenData.RelpeKorNm_02;
  } 
  // else {
  //   strInsr_Kor += "/" + state.screenData.RelpeKorNm_02;
  // }

  //3
  if ("" == state.screenData.RelpeKorNm_03) {
    strInsr_Kor += "";
  } else if ("" == strInsr_Kor) {
    strInsr_Kor += state.screenData.RelpeKorNm_03;
  } 
  // else {
  //   strInsr_Kor += "/" + state.screenData.RelpeKorNm_03;
  // }

  // 02 : 피보험자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = formData.form.adjtCd02;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = state.biz_no;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrId = formData.form.atlCtrId02;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrPtySeq = formData.form.atlCtrPtySeq02;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "02";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "피보험자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrId = formData.form.ctrId02;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = formData.form.ctrPtySeq02;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = sessionUserInfo.userInfo.corp_no;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = strInsr_Eng;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = strInsr_Kor;
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = sessionUserInfo.slzCusInf.cusNo;
  mrinSbcDsgCtrRelpeInfBcVo.hisSeq = formData.form.hisSeq02;
  mrinSbcDsgCtrRelpeInfBcVo.dataId =  formData.form.dataId02;
  mrinSbcDsgCtrRelpeInfBcVo.rowStat = formData.form.rowStat02;
  if (sessionUserInfo.userInfo.ind_corp_typ_cd == "C") {
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "4";
  } else {
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "2";
  }
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = formData.form.ptyDivCd02; // 당사자구분코드 (03 : 영업고객)
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = formData.form.ptyId02;

  mrinSbcDsgCtrRelpeInfBcVoLst.push(mrinSbcDsgCtrRelpeInfBcVo);

  // 23 : 검정업체 (Claim 지급지 )
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = formData.form.adjtCd23;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = state.biz_no;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrId = formData.form.atlCtrId23;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrPtySeq = formData.form.atlCtrPtySeq23;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "23";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "검정업체";
  mrinSbcDsgCtrRelpeInfBcVo.ctrId = formData.form.ctrId23;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = formData.form.ctrPtySeq23;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = ""; //보험 지급지
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = formData.form.ctrRelpeEngNm23;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = formData.form.ctrRelpeKorNm23;
  mrinSbcDsgCtrRelpeInfBcVo.hisSeq = formData.form.hisSeq23;
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = formData.form.ptyId23
  mrinSbcDsgCtrRelpeInfBcVo.dataId =  formData.form.dataId23;
  mrinSbcDsgCtrRelpeInfBcVo.rowStat = formData.form.rowStat23;
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = "";
  if (sessionUserInfo.userInfo.ind_corp_typ_cd == "C") {
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "4";
  } else {
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "2";
  }
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = formData.form.ptyDivCd23; // 당사자구분코드 (03 : 영업고객)

  mrinSbcDsgCtrRelpeInfBcVoLst.push(mrinSbcDsgCtrRelpeInfBcVo);

  // 11 : 질권자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = formData.form.adjtCd11;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = "";
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrId = formData.form.atlCtrId11;
  mrinSbcDsgCtrRelpeInfBcVo.atlCtrPtySeq = formData.form.atlCtrPtySeq11;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "11";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "질권자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = formData.form.ctrRelpeEngNm11;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = formData.form.ctrRelpeKorNm11;
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = "";
  mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "4";
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = formData.form.ptyDivCd11;
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = formData.form.ptyId11;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = formData.form.ctrPtySeq11;
  mrinSbcDsgCtrRelpeInfBcVo.dataId =  formData.form.dataId11;
  mrinSbcDsgCtrRelpeInfBcVo.rowStat = formData.form.rowStat11;

  mrinSbcDsgCtrRelpeInfBcVoLst.push(mrinSbcDsgCtrRelpeInfBcVo);

  //보험 목적물
  let strDtlCon = state.screenData.dtlCon;
  if ("" == strDtlCon) {
    strDtlCon = " ";
  }
  let prctrDtlConBcVo = {};
  prctrDtlConBcVo.ctrConCd = "G002"; // 계약내용코드 (G002 : 목적물 설명)
  prctrDtlConBcVo.hisSeq = "1";
  prctrDtlConBcVo.dtlSeq = "1";
  prctrDtlConBcVo.dtlCon = strDtlCon;

  prctrDtlConBcVoLst.push(prctrDtlConBcVo);

  //기타표시문헌 (t20 ~ t34)
  let strDtlCon_Etc = state.screenData.dtlCon_Etc;

  if ("" == strDtlCon_Etc) {
    strDtlCon_Etc = " ";
  }
  prctrDtlConBcVo = {};
  prctrDtlConBcVo.ctrConCd = "G003"; // 계약내용코드 (G003 : 추가문구)
  prctrDtlConBcVo.hisSeq = "1";
  prctrDtlConBcVo.dtlSeq = "2";
  prctrDtlConBcVo.dtlCon = strDtlCon_Etc;
  prctrDtlConBcVoLst.push(prctrDtlConBcVo);

  //워런티 추가(기본 문구 : SANCTION LIMITATION AND EXCLUSION CLAUSE)

  prctrDtlConBcVo = {};
  prctrDtlConBcVo.ctrConCd = "G009"; // 계약내용코드 (G009 : 워런티)
  prctrDtlConBcVo.dtlCon = "SANCTION LIMITATION AND EXCLUSION CLAUSE";
  prctrDtlConBcVoLst.push(prctrDtlConBcVo);

  let gnrMrinFtrnOdVo = {};
  gnrMrinFtrnOdVo.hisSeq = "1";
  gnrMrinFtrnOdVo.ftrnOdNm = state.screenData.ftrnOdNm;
  gnrMrinFtrnOdVo.trnMnCd = formData.form.trnMnCd;
  gnrMrinFtrnOdVo.ftrnOdSeq = formData.form.ftrnOdSeq;
  gnrMrinFtrnOdVoLst.push(gnrMrinFtrnOdVo);
      
  let cargSbcDsgObjInfBcVo = {};
  cargSbcDsgObjInfBcVo.hsCd = formData.form.hsCd;
  cargSbcDsgObjInfBcVo.invcVamt = formData.form.invcVamt;
  cargSbcDsgObjInfBcVo.invcVamtCurCd = formData.form.invcVamtCurCd;
  cargSbcDsgObjInfBcVo.itmCd = state.screenData.itmCd;
  cargSbcDsgObjInfBcVo.itmCdNm = formData.form.itmCdNm; //<![CDATA[모피&피혁류]]>
  cargSbcDsgObjInfBcVo.packCd = formData.form.packCd;
  CargSbcDsgObjInfBcVoLst.push(cargSbcDsgObjInfBcVo);

  // 수정 저장시 보내는 데이터
  let param = {
    acpShDivCd: formData.form.acpShDivCd,
    polNo: state.polNo,
    ctrId: formData.form.ctrId,
    endrHisStdNo: formData.form.endrHisStdNo,
    inetUsrId: state.screenData.logId,
    hisSeq: formData.form.hisSeq,
    agrmNagrmDiv: formData.form.agrmNagrmDiv,
    aplExrtDt: formData.form.aplExrtDt,
    ararCd: state.screenData.ararCd,
    ararNm: state.screenData.ararNm,
    basCovCd: formData.form.basCovCd,
    bizpeNo: state.bizpeNo,
    cargTrnDtlsDivCd: formData.form.cargTrnDtlsDivCd,
    cmcMnUstmnYn: formData.form.cmcMnUstmnYn,
    dsgDivCd: formData.form.dsgDivCd,
    dsgDt: formData.form.dsgDt,
    hopPftRt: state.screenData.hopPftRt,
    odshRt: state.screenData.odshRt,
    insStdt: state.screenData.insStdt,
    insVamtCurCd: formData.form.insVamtCurCd,
    pdCd: formData.form.pdCd,
    polOrtxtNum: state.screenData.polOrtxtNum,
    pyMd: formData.form.pyMd,
    refnNoCd1: state.screenData.refnNoCd1,
    refnNoCd2: state.screenData.refnNoCd2,
    refnNoDivCd1: formData.form.refnNoDivCd1,
    refnNoDivCd2: formData.form.refnNoDivCd2,
    sbcpChnDivCd: formData.form.sbcpChnDivCd,
    sbcpDt: state.screenData.sbcpDt,
    stplCd: state.screenData.stplCd,
    stplNm: state.screenData.stplNm,
    tkffDd: state.screenData.tkffDd,
    ttInvcVamtAmt: state.screenData.ttInvcVamtAmt,
    ttInvcVamtCur: state.screenData.ttInvcVamtCur,
    ttSbcAmt: formData.form.ttSbcAmt,
    untPdCd: formData.form.untPdCd,//sessionUserInfo.userInfo.expt_unit_prod_cd,
    uY: formData.form.uY,
    vygZoneCd: formData.form.vygZoneCd,
    trnMnCd1: formData.form.trnMnCd1,
    dsgDiv: formData.form.dsgDiv,
    polhdDiv: formData.form.polhdDiv,
    mrinSbcDsgCtrRelpeInfBcVo: mrinSbcDsgCtrRelpeInfBcVoLst,
    prctrDtlConBcVo: prctrDtlConBcVoLst,
    gnrMrinFtrnOdVo: gnrMrinFtrnOdVoLst,
    cargSbcDsgObjInfBcVo: CargSbcDsgObjInfBcVoLst,
    //mrinSbcDsgCovInfBcVo: Result.body.mrinSbcDsgCovInfBcVo,
  };                                        
  let ResultSave = await axios.transaction("FNGCTNFO0191", param);
  console.log("ResultSave", ResultSave);

  if (ResultSave.nErrorCode == "0") {
    axios.json('/logHisLdg.do', {memo:"증권 간략 정정 완료" ,page:window.location.hash});
    swalConfirm("증권이 정정 되었습니다.\n출력하시겠습니까?").then((result) => {
      let msg1 = "1";
      if (result.isConfirmed) {
        ResultSave.msg1 = msg1;
        fnPolPrint(ResultSave);
      }
    });
  } else {
    if(ResultSave.msg.standCd == "FNGCT200517"){
      swalAlert(ResultSave.msg.standMsg);
      return;
    }
  }
};

// var d1_ms = new Date(
//   state.screenData.sbcpDt.substring(0, 4),
//   Number(state.screenData.sbcpDt.substring(4, 6)) - 1,
//   state.screenData.sbcpDt.substring(6)
// );
// var d2_ms = new Date(
//   state.screenData.insStdt.substring(0, 4),
//   Number(state.screenData.insStdt.substring(4, 6)) - 1,
//   Number(state.screenData.insStdt.substring(6)) + 1
// );
// const onChangeinsStdt = () => {
//   var days = Math.abs(d1_ms - d2_ms) / (1000 * 60 * 60 * 24);
//   if (days >= 5) {
//     swalAlert("보험개시일은 청약일자의 5일 이내로만 입력 가능합니다.");
//     return false;
//   } else {
//     onChangetkffDd();
//     return true;
//   }
// };

const onChangetkffDd = () => {
  if (state.screenData.tkffDd < state.screenData.insStdt) {
    swalAlert("출항일은 개시일 이전일자로 입력 불가합니다.");
    state.screenData.insStdt  = "";
    return;
  }
};
const fnPolPrint = async (d) => {
  if (d.msg1 == "1") {
    //증권 출력시 보내줘야하는 데이터
    let param = {
      polNo: state.polNo,
      endrHisStdNo: d.body.endrHisStdNo,
      endrNo: d.body.endrNo,
      ctrId: d.body.ctrId,
      pdCd: "",
    };
    let Result = await axios.transaction("FNGCTGFO0137", param);
    // polPrintResult.value =  Result.body.cargInetCtrLstDtlInfBcVo;
    if (Result.msg.standCd != "FNGCT200549") {
      Result.body.ctrId = d.body.ctrId;
      Result.body.endrHisStdNo = d.body.endrHisStdNo;

      fnPolPrintRef.value.open(Result);
    } else {
      swalAlert(
        "미수증권으로 출력이 제어됩니다. 30일 이상 된 미수내역을 확인 바랍니다."
      );
      return;
    }
  }
};

const formatAmt = () => {
  if(_.endsWith(state.ttFormatInvcVamtAmt, '.')){
    return true;
  }
  console.log(state.ttFormatInvcVamtAmt)

  const rawAmt = state.ttFormatInvcVamtAmt?.replace(/[^0-9]+(\.[0-9]+)?$/g, "").replace(/,/g, "");
  console.log('-------rawAmt------')
  console.log(rawAmt)
  const formatted = new Intl.NumberFormat().format(rawAmt);
  console.log('-----formatted--------')
  console.log(formatted)
  state.ttInvcVamtAmt = rawAmt;
  state.ttFormatInvcVamtAmt = formatted;


};

init();

async function init() {
  await load();
  console.log(state.screenData);
  axios.json('/logHisLdg.do', {memo:"증권 간략 정정" ,page:window.location.hash});
}
</script>

<style></style>
